
/* injects from baggage-loader */
require('./style.styl');

import AggrSingleTouch from './AggrSingleTouch'

export default AggrSingleTouch



// WEBPACK FOOTER //
// ./client/views/AggreatedAttributionView/AggrSingleTouch/index.js